import { cn } from '@/lib/utils';

type Tone = 'up' | 'down' | 'brand' | 'warn';

interface SparklineProps {
  data: number[];
  width?: number;
  height?: number;
  tone?: Tone;
  filled?: boolean;
  animate?: boolean;
  className?: string;
}

const toneStroke: Record<Tone, string> = {
  up: 'rgb(var(--c-up))',
  down: 'rgb(var(--c-down))',
  brand: 'rgb(var(--c-brand))',
  warn: 'rgb(var(--c-warn))',
};

const toneFill: Record<Tone, string> = {
  up: 'rgb(var(--c-up) / 0.18)',
  down: 'rgb(var(--c-down) / 0.18)',
  brand: 'rgb(var(--c-brand) / 0.18)',
  warn: 'rgb(var(--c-warn) / 0.18)',
};

/** 极简 SVG sparkline。生产高保真换 lightweight-charts */
export function Sparkline({
  data,
  width = 120,
  height = 36,
  tone = 'up',
  filled = true,
  animate = true,
  className,
}: SparklineProps) {
  if (!data.length) return <div style={{ width, height }} className={className} />;

  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const stepX = data.length > 1 ? width / (data.length - 1) : width;

  const points = data
    .map((v, i) => {
      const x = i * stepX;
      const y = height - ((v - min) / range) * height;
      return `${x},${y.toFixed(2)}`;
    })
    .join(' ');

  const polyPath = `M ${points.replace(/ /g, ' L ')}`;
  const areaPath = `${polyPath} L ${width},${height} L 0,${height} Z`;

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className={cn('block', className)}>
      {filled && <path d={areaPath} fill={toneFill[tone]} />}
      <path
        d={polyPath}
        fill="none"
        stroke={toneStroke[tone]}
        strokeWidth={1.5}
        strokeLinejoin="round"
        strokeLinecap="round"
        className={animate ? 'spark-line' : undefined}
      />
    </svg>
  );
}
